import MGRAPI from '../interceptors/MgrApi';

export const getSubscriptions = () => MGRAPI.get('/subscriptions');
